import { captureException } from "@sentry/nextjs";
import { DECODED_TOKEN } from "@website/hooks/auth";
import { getCookie, removeCookie } from "@website/utils/cookie";
import jwtDecode from "jwt-decode";

export const decodeToken = (token: string): DECODED_TOKEN | null => {
  try {
    return jwtDecode(token) || null;
  } catch {
    captureException("Token was not decoded correctly", {
      tags: {
        errorType: "Token decoded",
        functionName: "decodeToken"
      }
    });
    return null;
  }
};

export const isTokenExpired = (
  token: string | null,
  currentTime: number
): boolean => {
  if (!token) return true;

  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) {
    captureException("Token exp is not valid", {
      tags: {
        errorType: "Token decoded",
        functionName: "isTokenExpired"
      }
    });
    return true;
  }

  const now = Math.floor(currentTime / 1000);
  return decoded.exp < now;
};

const getParentDomain = () => {
  try {
    const parts = window.location.hostname.split(".");
    return parts.slice(-2).join(".");
  } catch (error) {
    captureException(error);
    return "";
  }
};

// TODO: remove in a week after refresh tokens from today expire
export const removeLegacyToken = () => {
  const legacyToken = getCookie("access-token-legacy");
  const legacyRefreshToken = getCookie("refresh-token-legacy");
  if (legacyToken || legacyRefreshToken) {
    const parentDomain = getParentDomain();
    const options = { path: "/" };

    removeCookie("access-token-legacy", options);
    removeCookie("refresh-token-legacy", options);

    if (parentDomain) {
      removeCookie("access-token-legacy", {
        ...options,
        domain: parentDomain
      });
      removeCookie("refresh-token-legacy", {
        ...options,
        domain: parentDomain
      });
    }
  }
};
